import React from 'react'
import { Link } from 'react-router-dom'

const navItems = [
  { href: '#groupbuy', label: 'What is Group-Buy' },
  { href: '#how', label: 'How it works' },
  { href: '#story', label: 'Our Story' },
  { href: '#partner', label: 'Be Our Partner' },
]

const LandingNav = () => (
  <header className='landing-nav'>
    <div className='landing-shell landing-nav__inner'>
      <div className='landing-brand'>
        <div className='landing-brand__logo'>
          co<span>&middot;</span>bee
        </div>
        <div className='landing-brand__tagline'>Good Things Must Share</div>
      </div>

      <div className='landing-nav__menu'>
        <nav className='landing-nav__links' aria-label='Landing page sections'>
          {navItems.map((item) => (
            <a key={item.href} href={item.href} className='landing-nav__link'>
              {item.label}
            </a>
          ))}
        </nav>

        <div className='landing-nav__actions'>
          <Link to='/sign-in' className='landing-nav__cta'>
            Sign in
          </Link>
        </div>
      </div>
    </div>
  </header>
)

export default LandingNav
